// extracted by mini-css-extract-plugin
module.exports = {"Container":"LabelDiscount_Container___81J_"};